import { Breadcrumb } from "antd";
import { ColumnsType } from "antd/es/table";
import {
  CustomTable,
  CustomTextField,
  TableHeaderBar,
  TableHeaderInfo,
} from "~/components";
import { useLoaderData, useNavigate } from "react-router-dom";
import { useRouteActivity } from "~/hooks/useRouteActivity";
import * as APITypes from "~/API";
import { MessageTablePageLoaderType } from "./loaders/MessageTablePageLoader";
import { HomeOutlined } from "@ant-design/icons";
import {
  compareIsoDates,
  dateToLocalTime,
  getRouteWithParams,
  ROUTES,
} from "~/utils";

// TODO Translate
export const getMessageTableColumns = (): ColumnsType<APITypes.Message> => [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    width: 200,
    render: (_, record: APITypes.Message) => {
      return (
        <a
          href={getRouteWithParams("messageDetails", { messageID: record.id })}
        >
          {record.id}
        </a>
      );
    },
  },
  {
    title: "Message Title",
    dataIndex: "messageTitle",
    key: "messageTitle",
    width: 250,
    sorter: (a, b) =>
      (a.messageTitle || "").localeCompare(b.messageTitle || ""),
  },
  {
    title: "Date Sent",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 250,
    sorter: (a, b) => compareIsoDates(a.createdAt, b.createdAt),
    sortDirections: ["ascend", "descend"],
    defaultSortOrder: "descend",
    render: (_, record: APITypes.Message) => (
      <CustomTextField
        value={dateToLocalTime(record.createdAt, "dateTime")}
        onEmpty="n/a"
      />
    ),
  },
  {
    title: "Message",
    dataIndex: "content",
    key: "content",
    width: 250,
  },
];

export const MessageTablePage = () => {
  const loaderData = useLoaderData() as unknown as MessageTablePageLoaderType;
  const navigate = useNavigate();
  const { isTableLoading } = useRouteActivity();

  return (
    <>
      <Breadcrumb
        items={[
          {
            key: "home",
            title: (
              <HomeOutlined
                onClick={() => {
                  navigate(ROUTES.home);
                }}
              />
            ),
          },
          { key: "message", title: "Message" },
        ]}
        separator=">"
      />
      <section style={{ marginTop: "2rem" }}>
        <CustomTable
          tableHeaders={
            <TableHeaderBar
              left={
                <TableHeaderInfo
                  title="Messages"
                  count={loaderData.messages.length}
                  countLabel="messages"
                />
              }
            />
          }
          mobileCardConfig={{
            titleKey: "messageTitle",
            primaryKeys: ["createdAt"],
          }}
          mobileDefaultSort={{ dataIndex: "createdAt", order: "descend" }}
          tableProps={{
            dataSource: loaderData.messages,
            columns: getMessageTableColumns(),
            loading: isTableLoading,
          }}
        />
      </section>
    </>
  );
};
